var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheerWhiteArms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C3FBF1",
  d: "M7.156 14.054s-.093 3.64-3.187 2.553c-.58-.203-2.67-2.526-2.67-2.526l-.75.487a.153.153 0 0 1-.229-.172l.702-2.275.234-.774s1.299.78 1.806.936c.97.298 2.047.233 2.047.233z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#90F6DF",
  d: "M13.813 11.889s-.233 3.583-1.403 5.801l1.099.932a.246.246 0 0 1-.159.433H8.222c.824-3.767.865-7.166.865-7.166z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C3FBF1",
  d: "M4.868 3.464h9.507c.677 0 1.227.55 1.227 1.229v8.132c0 .679-.55 1.23-1.227 1.23H4.868c-.678 0-1.227-.551-1.227-1.23V4.693c0-.68.55-1.23 1.227-1.23"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#90F6DF",
  d: "M4.89 14.054h2.266L6.154 3.464H4.769c-.625 0-1.13.507-1.13 1.133V12.8c0 .692.56 1.253 1.25 1.253"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#031E29",
  d: "M8.752 7.106a.37.37 0 1 1 .001-.739.37.37 0 0 1 0 .739M13.744 7.106a.37.37 0 1 1 .001-.739.37.37 0 0 1 0 .739M9.789 6.486h3.086a1.72 1.72 0 0 1-1.543 2.481A1.72 1.72 0 0 1 9.79 6.486m1.141 2.108c.364.1.745-.132.745-.132s-.21-.394-.574-.494c-.365-.1-.746.132-.746.132s.21.394.575.494"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF662F",
  d: "m8.259 1.747.653.32c.062.047.167.029.196-.034l.547-.795c.06-.127.296-.127.355 0l.562.8c.029.063.134.081.196.034l.658-.333c.075-.057.203-.017.203.063l-.526 1.154c0 .072-.102.093-.186.09H8.775c-.087.004-.183-.006-.182-.078L8.056 1.81c0-.08.128-.12.203-.063"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.207,
  d: "M18.02 3.548c-.284 1.305-.913 2.083-2.42 2.938M18.682 3.206c.02.08.064.143.128.173.105.047.239-.006.349-.124a.7.7 0 0 0 .131-.2.7.7 0 0 0 .064-.25c.01-.153-.039-.28-.14-.326-.08-.035-.175-.014-.264.05"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.207,
  d: "M18.416 3.255c-.153-.07-.187-.327-.076-.575.111-.249.326-.394.48-.325.153.07.187.327.076.575s-.326.394-.48.325ZM19.582 3.514c-.095.077-.2.105-.286.066-.101-.045-.15-.172-.14-.325M19.839 3.043c.021-.168-.028-.313-.137-.362-.105-.047-.239.006-.348.123"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.207,
  d: "M20.044 3.47c-.09.202-.254.324-.365.274-.068-.03-.1-.12-.095-.23a.755.755 0 0 0 .254-.471c.059-.037.118-.05.168-.027.11.05.128.254.038.455ZM18.151 3.628c-.2-.09-.323-.254-.273-.365.05-.112.253-.129.454-.039.2.09.323.254.273.366s-.253.128-.454.038Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.207,
  d: "M20.078 3.38c-.523 3.257-1.803 4.346-4.477 5.834"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#031E29",
  strokeMiterlimit: 10,
  strokeWidth: 0.207,
  d: "M2.183 3.593c.284 1.304.912 2.082 2.419 2.937M.124 3.424C.648 6.681 1.928 7.77 4.602 9.258"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.207,
  d: "M1.256 2.572c-.09-.063-.185-.085-.264-.049-.102.046-.15.173-.14.326q.006.12.063.249.053.12.132.201c.11.118.243.17.348.123.065-.029.108-.091.128-.173"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.207,
  d: "M1.309 2.975c-.112-.248-.077-.506.076-.575.154-.069.368.076.48.325.111.248.077.505-.076.574-.154.07-.369-.076-.48-.324ZM1.046 3.299c.01.152-.04.28-.14.325-.086.039-.192.01-.287-.066M.852 2.849c-.11-.118-.244-.171-.349-.124-.109.05-.158.194-.137.362"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.207,
  d: "M.16 3.515c.09.2.254.323.365.273.068-.03.101-.12.096-.23a.753.753 0 0 1-.254-.471c-.06-.037-.12-.05-.169-.027-.11.05-.128.254-.038.455ZM1.597 3.635c-.05-.112.072-.275.273-.366.2-.09.404-.073.454.038.05.112-.073.275-.273.366s-.404.073-.454-.038Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.207,
  d: "M2.186 3.593c.284 1.304.861 1.824 1.447 2.263M.126 3.424C.65 6.681 2.168 7.686 3.56 8.638"
})));
export default SvgCheerWhiteArms;